module.exports = __webpack_public_path__ + "img/acc10.e1602262.png";